var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserFrameBronze(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 647.962,
    height: 595.574,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style13993"
  }, ".st12,.st2,.st7{fill:#ffd5c2}.st12,.st7{opacity:.5}.st12{fill:#5e1732}")), /*#__PURE__*/React.createElement("g", {
    id: "g14316",
    transform: "translate(-135.303 -145.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14049"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 988.472,
    y1: 686.989,
    x2: 988.472,
    y2: 72.483,
    gradientTransform: "rotate(-41.721 567.348 1286.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fa8978"
    },
    id: "stop14023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    style: {
      stopColor: "#f47e6e"
    },
    id: "stop14025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    style: {
      stopColor: "#e56254"
    },
    id: "stop14027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    style: {
      stopColor: "#cc342b"
    },
    id: "stop14029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    style: {
      stopColor: "#b70d07"
    },
    id: "stop14031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a61d1b"
    },
    id: "stop14033"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 988.349,
    y1: 615.689,
    x2: 988.349,
    y2: 71.681,
    gradientTransform: "rotate(-41.721 567.348 1286.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#cf2f2f"
    },
    id: "stop14038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#5e1414"
    },
    id: "stop14040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6f47"
    },
    id: "stop14042"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g14095"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.032,
    y1: 660.092,
    x2: 461.032,
    y2: 145.429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7d2222"
    },
    id: "stop14051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    style: {
      stopColor: "#780b0b"
    },
    id: "stop14053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    style: {
      stopColor: "#912f2a"
    },
    id: "stop14055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    style: {
      stopColor: "#be6e61"
    },
    id: "stop14057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    style: {
      stopColor: "#de9c8a"
    },
    id: "stop14059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921,
    style: {
      stopColor: "#f3b8a3"
    },
    id: "stop14061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fac3ac"
    },
    id: "stop14063"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M461.03 145.43c-142.1 0-257.33 115.23-257.33 257.33 0 142.1 115.23 257.33 257.33 257.33 142.17 0 257.33-115.23 257.33-257.33 0-142.1-115.16-257.33-257.33-257.33zm0 484.34c-125.32 0-226.95-101.63-226.95-227.01s101.63-227.02 226.95-227.02c125.38 0 227.02 101.63 227.02 227.02 0 125.38-101.64 227.01-227.02 227.01z",
    id: "path14066",
    style: {
      fill: "url(#SVGID_5_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.065,
    y1: 652.662,
    x2: 461.065,
    y2: 152.859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff7f5e"
    },
    id: "stop14068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    style: {
      stopColor: "#e55643"
    },
    id: "stop14070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    style: {
      stopColor: "#d2372e"
    },
    id: "stop14072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#c62421"
    },
    id: "stop14074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#c21d1d"
    },
    id: "stop14076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    style: {
      stopColor: "#d13d35"
    },
    id: "stop14078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    style: {
      stopColor: "#e76b56"
    },
    id: "stop14080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    style: {
      stopColor: "#f5876b"
    },
    id: "stop14082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fa9273"
    },
    id: "stop14084"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M461.03 152.86c-137.99 0-249.83 111.92-249.83 249.9 0 138.05 111.85 249.9 249.83 249.9 138.05 0 249.9-111.85 249.9-249.9 0-137.99-111.85-249.9-249.9-249.9zm0 476.91c-125.32 0-226.95-101.63-226.95-227.01s101.63-227.02 226.95-227.02c125.38 0 227.02 101.63 227.02 227.02 0 125.38-101.64 227.01-227.02 227.01z",
    id: "path14087",
    style: {
      fill: "url(#SVGID_6_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M290.21 224.25c-3.81 18.2 5.91 18.25 9.34 15.58 35.59-27.73 84.53-69.67 170.43-63.86 65.74 4.44 124.82 28.9 154.63 66.08 13.76 17.15 22.5 17.36 25.55 10.14 3.05-7.22-23.66-99.29-175.98-99.29-152.3-.01-182.43 64.02-183.97 71.35z",
    id: "path14089"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.99 564.96s73.79 77.57 190.06 77.57 190.09-77.57 190.09-77.57-66.95 87.7-190.09 87.7-190.06-87.7-190.06-87.7z",
    id: "path14091",
    style: {
      opacity: 0.8,
      fill: "#ffd5c2"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M350.37 187.43c-10.41 22.27 45.4-5.72 63.79-11.81 17.48-5.78-50.47-16.69-63.79 11.81z",
    id: "path14093"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g14172"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 685.59,
    y1: 612.967,
    x2: 685.59,
    y2: 293.828
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d75f50"
    },
    id: "stop14097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#a10b0b"
    },
    id: "stop14099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#af1a16"
    },
    id: "stop14101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    style: {
      stopColor: "#d74835"
    },
    id: "stop14103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    style: {
      stopColor: "#f16449"
    },
    id: "stop14105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fa6f50"
    },
    id: "stop14107"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M780.98 398.21c-12.25 63.94-73.63 137.83-137.43 183.24-18.78 13.3-37.73 24.17-55.63 31.51 3.36-3.82 107.61-123.57 139.14-212.94 31.17-88.63-3.47-97.21-1.85-105 .88-4.29 22.48 2.8 38.95 23.52l.13.06c13.51 16.9 23.72 42.95 16.69 79.61z",
    id: "path14110",
    style: {
      fill: "url(#SVGID_7_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 691.52,
    y1: 450.442,
    x2: 691.52,
    y2: 169.924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d75f50"
    },
    id: "stop14112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#a10b0b"
    },
    id: "stop14114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#af1a16"
    },
    id: "stop14116"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    style: {
      stopColor: "#d74835"
    },
    id: "stop14118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    style: {
      stopColor: "#f16449"
    },
    id: "stop14120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fa6f50"
    },
    id: "stop14122"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M708.84 419.58c0 .07 0 .14-.07.2-5.87 17.76-11.19 29.13-11.94 30.65 15.07-51.72 13.41-135.81-25.62-159.8 0 0-25.24-91.16-28.62-114.71-.36-2.87-.47-4.75-.13-5.34 3.81-6.5 90.01 34.1 97.92 127.65 3.91 46.04-22.17 93.05-31.54 121.35z",
    id: "path14125",
    style: {
      fill: "url(#SVGID_8_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 616.581,
    y1: 736.476,
    x2: 616.581,
    y2: 444.836
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d75f50"
    },
    id: "stop14127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#a10b0b"
    },
    id: "stop14129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#af1a16"
    },
    id: "stop14131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    style: {
      stopColor: "#d74835"
    },
    id: "stop14133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    style: {
      stopColor: "#f16449"
    },
    id: "stop14135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fa6f50"
    },
    id: "stop14137"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M759.8 571.96c-11.15 44.52-175.26 58.43-225.08 88.84-41.03 25.05-35.38 37.25-27.82 41.69 1.78 1.03 3.65 1.61 5.09 1.86 7.26 1.26-5.63-18.77 16.16-24.03 21.57-5.15 22.45 18.81 16.43 26.62 0 0-19.11 30.63-49.58 29.5-25.29-.98-34.78-61.53-25.04-95.71v-.07c2.01-7.2 4.92-13.21 8.72-17.27 21.49-23.03 115.32 4.17 189.89-62.8 72.18-64.82 90.74-106.05 94.52-115.14 1.26-3.07 2.56 5.4 3.33 19.55v.13c1.34 27.81.61 77.69-6.62 106.83z",
    id: "path14140",
    style: {
      fill: "url(#SVGID_9_)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M759.8 571.96c-11.15 44.52-175.26 58.43-225.08 88.84-41.03 25.05-35.38 37.25-27.82 41.69 0 0-31.29-30-14.53-70.73 16.57-40.28 97.98.03 188.72-36.33 69.5-27.94 82.77-100.88 85.32-130.28 1.35 27.79.62 77.67-6.61 106.81z",
    id: "path14142"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M544.57 706.94s-19.11 30.63-49.58 29.5c-25.29-.98-34.78-61.53-25.04-95.71-.08 2.89-1.13 69.94 26.03 81.84 27.59 12.09 41.48-21.96 42.14-29.73.59-7.82-9.99-12.53-9.99-12.53 21.58-5.14 22.46 18.82 16.44 26.63z",
    id: "path14144"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M780.98 398.21c-12.25 63.94-73.63 137.83-137.43 183.24-13.5 7.24-24.46 12.18-30.1 12.8 0 0 110.76-102.58 140.11-168.07 28.79-64.28 10.59-107.64 10.59-107.64l.13.06c13.52 16.9 23.73 42.95 16.7 79.61z",
    id: "path14146"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M708.84 419.58c0 .07 0 .14-.07.2-5.87 17.76-11.19 29.13-11.94 30.65 15.07-51.72 13.41-135.81-25.62-159.8 0 0-25.24-91.16-28.62-114.71l1-.13s42.26 32.1 58.16 83.69c15.99 51.89 13.83 125.93 7.09 160.1z",
    id: "path14148"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M689.68 475.17s39.8 3.19 56.01-33.71c16.03-36.51 27.25-77.63 18.01-102.38-9.23-24.71-22.95-20.02-22.95-20.02s6.86 11.67-6.41 57.53c-13.43 46.4-44.66 98.58-44.66 98.58z",
    id: "path14150"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M609.42 595.76s66.04 18.54 104.43-19.61c37.73-37.51 38.76-92.44 35.38-95.77-3.38-3.33-10.95 12.38-58.8 59.76-48.91 48.43-81.01 55.62-81.01 55.62z",
    id: "path14152"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M657.45 188.31s43.96 36.07 51.35 101.56c7.46 66.11 27.65 11.63 26.88-18.7-.77-30.17-39.97-73.3-78.23-82.86z",
    id: "path14154"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M563.75 612.18s86.63 1.53 138.81-35.36c51.12-36.13 61.65-94.85 61.65-94.85s-2.43 76.48-70.32 108.33c-60.61 28.45-130.14 21.88-130.14 21.88z",
    id: "path14156"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M673.63 533.58s73.38-86.24 84.42-124.6c10.94-37.99 11.48-62.96 11.48-62.96s24.64 72.74-95.9 187.56z",
    id: "path14158"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M657.45 188.31s57.7 47.99 56.24 182.27c-.01 0 18.37-120.64-56.24-182.27z",
    id: "path14160"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M470.29 655.27c3.75 29.68 15-22.04 27.87-32.28 12.81-10.19-27.98-17.32-27.87 32.28z",
    id: "path14162"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M506.07 619.73c-12.85 6.67-22.66 37.73-12.9 53.33 9.76 15.59 24.21-12.63 89.32-32.31 63.77-19.28-39.45-40.2-76.42-21.02z",
    id: "path14164"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M768.79 372.78c-8.53-27.13-13.68 30.54-10.74 36.2 2.94 5.66 15.26-21.83 10.74-36.2z",
    id: "path14166"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M678.81 196.91c-8.78-2.22 12.97 49.26 23.01 55.78 10.01 6.5 17.02-45.64-23.01-55.78z",
    id: "path14168"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M487.72 716.45c-5.87-16.7 23.06-4.05 35.56-9.74 12.45-5.66-.12 19.06-16.91 18.4-16.87-.65-18.65-8.66-18.65-8.66z",
    id: "path14170"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g14270"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 513.534,
    y1: 612.032,
    x2: 513.534,
    y2: 290.704,
    gradientTransform: "matrix(-1 0 0 1 749.061 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d75f50"
    },
    id: "stop14195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#a10b0b"
    },
    id: "stop14197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#af1a16"
    },
    id: "stop14199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    style: {
      stopColor: "#d74835"
    },
    id: "stop14201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    style: {
      stopColor: "#f16449"
    },
    id: "stop14203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fa6f50"
    },
    id: "stop14205"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.61 393.67c12.41 63.91 75 138.84 140.59 185.58 19.41 13.77 39.03 25.09 57.56 32.79-3.51-3.95-111.35-126.58-143.73-216.3-31.61-87.85 3.14-96.18 1.49-103.85-.89-4.21-22.55 2.69-39.03 23.02l-.13.06c-13.58 16.6-23.83 42.3-16.75 78.7z",
    id: "path14208",
    style: {
      fill: "url(#SVGID_11_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 522.195,
    y1: 446.279,
    x2: 522.195,
    y2: 169.925,
    gradientTransform: "matrix(-1 0 0 1 749.061 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d75f50"
    },
    id: "stop14210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#a10b0b"
    },
    id: "stop14212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#af1a16"
    },
    id: "stop14214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    style: {
      stopColor: "#d74835"
    },
    id: "stop14216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    style: {
      stopColor: "#f16449"
    },
    id: "stop14218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fa6f50"
    },
    id: "stop14220"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.53 415.33c0 .07 0 .13.07.2 6.04 17.79 11.49 29.21 12.26 30.74-15.53-51.77-14.24-135.06 24.87-158.56 0 0 24.61-89.1 27.79-111.97.34-2.78.43-4.61.09-5.18-3.86-6.3-89.69 33.05-97.33 124.44-3.8 45.35 22.65 92.08 32.25 120.33z",
    id: "path14223",
    style: {
      fill: "url(#SVGID_12_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.743,
    y1: 741,
    x2: 441.743,
    y2: 440.26,
    gradientTransform: "matrix(-1 0 0 1 749.061 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d75f50"
    },
    id: "stop14225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    style: {
      stopColor: "#a10b0b"
    },
    id: "stop14227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#af1a16"
    },
    id: "stop14229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    style: {
      stopColor: "#d74835"
    },
    id: "stop14231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    style: {
      stopColor: "#f16449"
    },
    id: "stop14233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fa6f50"
    },
    id: "stop14235"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.23 568.52c11.48 45.52 180.24 61.45 232.21 93.35 43.04 26.43 37.41 39.03 29.62 43.56a16.38 16.38 0 0 1-5.26 1.88c-7.53 1.22 5.51-19.44-17.21-25.15-22.45-5.58-23 19.25-16.62 27.45 0 0 20.4 32.17 52.14 31.38 26.38-.7 34.98-63.66 24.12-99.15v-.07c-2.23-7.45-5.38-13.69-9.4-17.9-22.7-23.91-119.15 3.11-196.44-66.1-73.93-66.2-92.85-107.75-96.68-116.88-1.28-3.08-2.59 5.39-3.35 19.56v.13c-1.34 27.93-.54 78.3 6.87 107.94z",
    id: "path14238",
    style: {
      fill: "url(#SVGID_13_)"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M159.23 568.52c11.48 45.52 180.24 61.45 232.21 93.35 43.04 26.43 37.41 39.03 29.62 43.56 0 0 31.96-30.79 13.75-73.1-17.9-41.59-101.31-.99-195-39.16-71.2-29.11-84.82-103.01-87.45-132.58-1.34 27.92-.54 78.29 6.87 107.93z",
    id: "path14240"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M381.97 709.6s20.4 32.17 52.14 31.38c26.38-.7 34.98-63.66 24.12-99.15.14 2.99 2.65 72.58-25.43 84.66-28.53 12.27-43.56-23.38-44.37-31.46-.74-8.13 10.16-12.88 10.16-12.88-22.45-5.58-23 19.26-16.62 27.45z",
    id: "path14242"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M137.61 393.67c12.41 63.91 75 138.84 140.59 185.58 13.93 7.52 25.24 12.67 31.05 13.36 0 0-113.99-105.07-143.94-170.93-29.09-64.04-10.83-106.78-10.83-106.78l-.13.06c-13.57 16.61-23.82 42.31-16.74 78.71z",
    id: "path14244"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M210.53 415.33c0 .07 0 .13.07.2 6.04 17.79 11.49 29.21 12.26 30.74-15.53-51.77-14.24-135.06 24.87-158.56 0 0 24.61-89.1 27.79-111.97l-1-.13s-42.02 31.16-57.65 81.47c-15.8 50.91-13.32 124.17-6.34 158.25z",
    id: "path14246"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M230.27 471.16s-40.43 2.95-56.96-34.18c-16.27-36.52-27.62-77.4-18.35-101.83 9.23-24.33 23.02-19.66 23.02-19.66s-6.86 11.48 6.61 56.91c13.73 46.26 45.68 98.76 45.68 98.76z",
    id: "path14248"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.4 594.19s-67.69 18.35-107.24-20.99c-38.62-38.42-39.78-93.87-36.35-97.19 3.42-3.32 11.14 12.53 60.1 60.79 50.43 49.73 83.49 57.39 83.49 57.39z",
    id: "path14250"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M260.78 187.76s-43.74 35.05-50.82 99.11c-7.21 65.18-27.72 11.36-27.03-18.4.67-29.5 39.66-71.45 77.85-80.71z",
    id: "path14252"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M360.66 611.46s-89.19.71-142.96-37.48c-52.3-37.15-63.1-96.48-63.1-96.48s2.57 77.28 72.04 110.31c62.47 29.71 134.02 23.65 134.02 23.65z",
    id: "path14254"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247.01 530.27s-75.03-87.41-86.27-125.78c-11.07-37.8-11.64-62.51-11.64-62.51s-24.8 72.06 97.91 188.29z",
    id: "path14256"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260.78 187.76s-57.43 46.66-55.37 178.78c0-.01-18.93-118.84 55.37-178.78z",
    id: "path14258"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M458.19 656.86c-3.28 30.73-16.02-22.94-29.55-33.62-13.45-10.61 28.62-17.55 29.55 33.62z",
    id: "path14260"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M420.38 619.81c13.43 7 24.22 39.18 14.39 55.22-9.85 16.07-25.37-13.35-93.06-34.38-65.93-20.48 40.15-40.92 78.67-20.84z",
    id: "path14262"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.86 368.47c8.55-26.82 13.83 30.4 10.87 36.02-2.95 5.63-15.4-21.79-10.87-36.02z",
    id: "path14264"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.48 196.1c8.77-2.16-12.68 47.99-22.7 54.34-10.01 6.34-17.24-44.51 22.7-54.34z",
    id: "path14266"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M441.3 720.21c5.78-17.32-24.1-4.5-37.21-10.58-13.03-6.04.45 19.85 17.94 19.39 17.58-.48 19.27-8.81 19.27-8.81z",
    id: "path14268"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 538.285,
    cy: 616.957,
    r: 46.969,
    gradientTransform: "matrix(-.1873 .6983 -.3544 -.095 1079.439 70.377)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#a68f95"
    },
    id: "stop14272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop14274"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 522.381,
    cy: 2143.783,
    r: 46.969,
    gradientTransform: "matrix(-.1873 .6983 -.3544 -.095 1079.439 70.377)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#a68f95"
    },
    id: "stop14279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop14281"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 772.105,
    cy: 1403.225,
    r: 46.278,
    gradientTransform: "matrix(.7749 -.3013 .133 .342 -71.01 348.093)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a68f95"
    },
    id: "stop14288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop14290"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 241.773,
    cy: 1243.832,
    r: 46.281,
    gradientTransform: "matrix(.803 .2154 -.095 .3544 159.547 109.075)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a68f95"
    },
    id: "stop14295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop14297"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 739.892,
    cy: 1356.521,
    r: 74.818,
    gradientTransform: "matrix(-.2282 -.7995 .3528 -.1007 408.644 1004.266)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a68f95"
    },
    id: "stop14302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop14304"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 808.707,
    cy: -12.057,
    r: 74.823,
    gradientTransform: "matrix(-.4727 -.6839 .3018 -.2086 568.819 975.867)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a68f95"
    },
    id: "stop14309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop14311"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFrameBronze);
export default __webpack_public_path__ + "static/media/user_frame_bronze.1943bf25c55dbdfb1af00362d34566f3.svg";
export { ForwardRef as ReactComponent };